import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import ConfigContext from '../../../contexts/ConfigContext';
import usePagination from '../../../hooks/usePagination';

// Redux
import { useGetEventsQuery } from '../../../redux/slices/eventSlice';

// Components
import SearchEvent from './SearchEvent';
import Loader from '../../shared/Loader';
import Paginate from '../../shared/Paginate';
import FilterList from './FilterList';

// Styles
import paginateRoundTheme from '../../shared/Paginate-round.module.postcss';
import styles from './Search.module.postcss';

function SearchResults({ setSearchResults, query, page, day, foodCategories, setHoverLocation, openNow = false, tomorrow = false, swLat, swLng, neLat, neLng }) {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleLowerCase = vehicle_type.toLowerCase();

  const { data = {}, isLoading, isFetching } = useGetEventsQuery({
    include_bookings: true,
    for_map: true,
    with_booking_status: 'approved',
    page: page || 1,
    ...(query ? { search: query } : {}),
    ...(foodCategories ? { for_food_categories: foodCategories } : {}),
    ...(day ? { on_day: day } : {}),
    ...(tomorrow ? { on_day: dayjs().add(1, 'day').format('YYYY-MM-DD') } : {}),
    ...(openNow ? { open_now: true } : {}),
    ...(swLat && swLng && neLat && neLng ? { sw_lat: swLat, sw_lng: swLng, ne_lat: neLat, ne_lng: neLng } : {})
  });
  const events = data.events || [];
  const pagination = data.pagination;
  const hasEvents = events.length > 0;

  useEffect(() => {
    setSearchResults(data.events);
  }, [data.events, setSearchResults]);

  const { paginationProps, showPagination } = usePagination({
    pagination,
    options: { theme: paginateRoundTheme, previousLabel: '<', nextLabel: '>' }
  });

  return (
    <section className='InnerSection'>

      <div className={styles.SearchResults_Header}>
        <h1>All Results</h1>

        <FilterList
          query={query}
          day={day}
          foodCategories={foodCategories}
          openNow={openNow}
          tomorrow={tomorrow}
        />
      </div>

      <Loader isLoading={isLoading}>
        { !hasEvents &&
          <div className={styles.SearchResults_Empty}>
            <div>
              <p>No open {vehicleLowerCase}s found for current search.</p>
              <p>Try using different or fewer keywords, moving the map, or removing search filters.</p>
            </div>
            <Link to='/search' className='Button'>View All</Link>
          </div>
        }

        { hasEvents &&
          <>
            <div className={styles.SearchResults}>
              { events.map((event) =>
                event.bookings.map((booking) =>
                  <SearchEvent
                    key={'searchResult-' + booking.id}
                    event={event}
                    booking={booking}
                    onMouseEnter={() => setHoverLocation(event.location_id)}
                    onMouseLeave={() => setHoverLocation(null)}
                  />
                ))
              }
            </div>
            { showPagination && <Paginate {...paginationProps} /> }
          </>
        }
      </Loader>

    </section>
  );
}

SearchResults.propTypes = {
  setSearchResults: PropTypes.func.isRequired,
  query: PropTypes.string,
  page: PropTypes.string,
  day: PropTypes.string,
  setHoverLocation: PropTypes.func.isRequired,
};

export default SearchResults;
